import { InputCloneMode } from "../../../../poly/InputCloneMode";
import { TypeAssert } from "../../../../poly/Assert";
import { NodeEvent } from "../../../../poly/NodeEvent";
import { CoreType } from "../../../../../core/Type";
export class ClonedStatesController {
  constructor(inputs_controller) {
    this.inputs_controller = inputs_controller;
    this._cloneRequiredStates = [];
    this._overridden = false;
    this.node = inputs_controller.node;
  }
  initInputsClonedState(states) {
    if (CoreType.isArray(states)) {
      this._clonedStates = states;
    } else {
      this._clonedState = states;
    }
    this._updateCloneRequiredState();
  }
  overrideClonedStateAllowed() {
    if (this._clonedStates) {
      for (let state of this._clonedStates) {
        if (state == InputCloneMode.FROM_NODE) {
          return true;
        }
      }
    }
    if (this._clonedState) {
      return this._clonedState == InputCloneMode.FROM_NODE;
    }
    return false;
  }
  cloneRequiredState(index) {
    const result = this._cloneRequiredStates[index];
    return result;
  }
  cloneRequiredStates() {
    return this._cloneRequiredStates;
  }
  _getCloneRequiredState(index) {
    const states = this._clonedStates;
    if (states) {
      const state = states[index];
      if (state != null) {
        return this._cloneRequiredFromState(state);
      }
    }
    if (this._clonedState) {
      return this._cloneRequiredFromState(this._clonedState);
    }
    return true;
  }
  _cloneRequiredFromState(state) {
    switch (state) {
      case InputCloneMode.ALWAYS:
        return true;
      case InputCloneMode.NEVER:
        return false;
      case InputCloneMode.FROM_NODE:
        return !this._overridden;
    }
    return TypeAssert.unreachable(state);
  }
  overrideClonedState(state) {
    this._overridden = state;
    this._updateCloneRequiredState();
    this.node.emit(NodeEvent.OVERRIDE_CLONABLE_STATE_UPDATE);
    this.node.setDirty();
  }
  overriden() {
    return this._overridden;
  }
  _updateCloneRequiredState() {
    if (this._clonedStates) {
      const states = [];
      for (let i = 0; i < this._clonedStates.length; i++) {
        states[i] = this._getCloneRequiredState(i);
      }
      this._cloneRequiredStates = states;
    } else {
      if (this._clonedState) {
        const max_inputs = this.inputs_controller.maxInputsCount();
        const states = [];
        for (let i = 0; i < max_inputs; i++) {
          states[i] = this._getCloneRequiredState(i);
        }
        this._cloneRequiredStates = states;
      }
    }
  }
}
